export const CREATE_ORDER = "CREATE_ORDER"
export const CREATE_ORDER_MOMO = "CREATE_ORDER_MOMO"
export const CREATE_ORDER_VNPAY = "CREATE_ORDER_VNPAY"
export const UPDATE_STATUS = "UPDATE_STATUS"
export const GET_ORDER_OF_CUSTOMER = "GET_ORDER_OF_CUSTOMER"
export const GET_ORDER = "GET_ORDER"